export enum ReeferInterfaceStatusCategory {
    Unknown = -1,
    ModeA = 0,
    ModeB = 1,
    ModeC = 2
}
